import { cva } from 'cva'

export const selectableCardStyle = cva({
  base: [
    'relative',
    'flex',
    'items-center',
    'gap-3',
    'px-4',
    'py-3',
    'rounded-xl',
    'border',
    'cursor-pointer',
    'transition-colors',
    'w-full',
    ['data-[selected=selected]:border-green-500', 'data-[selected=selected]:bg-green-100'],
    ['data-[selected=un-selected]:border-gray-200', 'data-[selected=un-selected]:bg-white'],
  ],

  variants: {
    size: {
      default: [],
      compact: ['py-5', 'px-2', 'justify-center'],
    },
  },

  defaultVariants: {
    size: 'default',
  },
})
